module.exports = __webpack_public_path__ + "static/media/idee2.0b3ce4ff.jpg";